<router-outlet> </router-outlet>
<app-landing-switcher></app-landing-switcher>